import { bootstrapApplication, disableDebugTools } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { isDevToolsProtectionEnabled } from './app/core/services/devtools-protection.service';
import { captureUserActivationAtEntry } from './app/shared/utils/wait-for-real-user-visit.util';

// Sticky activation del clic del correo antes del bootstrap (anti-prefetch Gmail/Outlook).
captureUserActivationAtEntry();

if (isDevToolsProtectionEnabled()) {
	try {
		disableDebugTools();
	} catch {
		// Debug tools pueden no estar habilitadas en este build.
	}
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
